module.exports = __webpack_public_path__ + "img/info-item-2.dbf1c417.png";